import { Box } from '@mui/material';
import { Chart, ChartOption } from '@/components/Base/Chart';

interface Props {
  data: { disciplina: string; media: number }[];
}

const BarChartDisciplinas: React.FC<Props> = ({ data }) => {
  const sorted = [...data].sort((a, b) => a.media - b.media);
  const disciplinas = sorted.map((d) => d.disciplina);
  const valores = sorted.map((d) => ({
    value: d.media,
    itemStyle: {
      color: d.media >= 7 ? '#1c9c7c' : d.media >= 5 ? '#FDC500' : '#DF4A4C',
    },
  }));

  const barHeight = 32;
  const containerHeight = Math.max(400, data.length * barHeight + 80);

  const option: ChartOption = {
    title: {
      text: 'Média por Disciplina',
      textStyle: { fontSize: 14 },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
    },
    grid: { left: '4%', right: '8%', top: 40, bottom: 10, containLabel: true },
    xAxis: {
      type: 'value',
      min: 0,
      max: 10,
    },
    yAxis: {
      type: 'category',
      data: disciplinas,
      axisLabel: {
        width: 140,
        overflow: 'truncate',
      },
    },
    series: [
      {
        type: 'bar',
        data: valores,
        barMaxWidth: 24,
        label: {
          show: true,
          position: 'right',
          formatter: '{c}',
          fontWeight: 'bold',
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: '14px',
        border: '1px solid rgba(176, 176, 176, 1)',
        p: '16px',
        overflow: 'auto',
        maxHeight: '600px',
      }}
      height={`${containerHeight}px`}
    >
      <Chart option={option} />
    </Box>
  );
};

export default BarChartDisciplinas;
